<template>
  <div class="py-5 text-center abbv-wrapper">
    <div class="container">
      <div v-html="$t('Footer.legalrules')" class="small"></div>
    </div>
  </div>
  <footer class="py-4">

    <div class="navbar px-4 py-0">
      <div class="col">
        <ul class="list-inline mb-0" id="footer-nav">
          <li class="list-inline-item ps-0" v-html="$t('Footer.T&CLink')">
          </li>
          <li class="list-inline-item" v-html="$t('Footer.PrivayPolicyLink')">
          </li>
          <li class="list-inline-item" v-html="$t('Footer.ContactUsLink')">
          </li>
        </ul>
        <p class="mt-4 mt-sm-1 mb-0 pe-md-5 small">
          <span v-html="$t('Footer.copyrighttext')"></span> {{ new Date().getFullYear() }}. {{
            $t('Footer.AllrightReserved') }}
        </p>

      </div>
      <div class="footer-right me-0 me-sm-5">
        <div class="footer-social-nav">
          <ul class="list-inline m-0">
            <li class="fw-bold">{{ $t('Footer.FollowUs') }}</li>
            <li>
              <a href="https://www.facebook.com/zukescanada" class="fb-link social-icon" title="facebook"
                target="_blank">
                <i class="fab fa-facebook"></i>
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/zukescanada" class="ig-link social-icon" title="instagram"
                target="_blank">
                <i class="fab fa-instagram"></i>
              </a>
            </li>
            <li>
              <a href="https://www.snapchat.com/add/zukescanada" class="sc-link social-icon" title="snapchat"
                target="_blank">
                <i class="fab fa-snapchat"></i>
              </a>
            </li>
            <li class="fw-bold"><a href="https://www.zukes.com/canada" target="_blank">{{ $t('Footer.LearnMore') }}
                <i class="fas fa-arrow-up-right-from-square"></i>
              </a>
            </li>
          </ul>
        </div>

      </div>
    </div>
  </footer>
</template>

<script>
//Younet chatbot code apprended in the body
export default {
  mounted() {
    // // Dynamically fetch the translated modelHash
    const modelHash = this.$t('YounetmodelHash');
    const modelImgurl = this.$t('YounetmodelIMg');
    const scriptUrl = `https://widget.younet.ai/index.js?modelHash=${modelHash}&type=bubble&imgUrl=${modelImgurl}&bottom=90`;

    // // Dynamically create the script element
    const script = document.createElement('script');
    script.type = 'module';
    script.src = scriptUrl;

    // // Append the script to the body
    document.body.appendChild(script);
  },
};
</script>